// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__V_8KZ","heading":"styles_heading__hohBo","container":"styles_container__P1N7G"};